import { Button, CircularProgress, Dialog, makeStyles } from '@material-ui/core';
import React, { useContext,  useMemo } from 'react'
import AppContext from '../../../AppContext';
import { item_not_applicable_document_request, useGetItemNotApplicableDocumentWithContent } from '../../../services/AdminDocument/AdminDocumentRead/AdminDocumentRead';
import { useTranslation } from 'react-i18next';


const useStyles = makeStyles(theme => ({
    root: {
        position: "relative",
    },
    page: {
        
    },
    buttonToClose: {
        position: "sticky",
        bottom: theme.spacing(2),
        left: theme.spacing(2),
        backgroundColor: theme.palette.primary.main,
        color: "white"
    }
}))

export const testIds = {
    document: "document",
    buttonToClose: "button_to_close_document_dialog" 
}

export interface ItemNotApplicableDocumentDialogProps {
    open: boolean;
    pageNumber: number;
    onCloseDialog: () => void
    categoryLocation: string;
}   

const ItemNotApplicableDocumentDialog: React.FC<ItemNotApplicableDocumentDialogProps> = ({ open,  pageNumber, onCloseDialog, categoryLocation }) => {
    const { language } = useContext(AppContext);
    const category = categoryLocation === "Centre" ? "item_not_applicable_category_center" : "item_not_applicable_category_housing"
    const { data: itemNotApplicableDocument, loading: loadingitemNotApplicableDocument } = useGetItemNotApplicableDocumentWithContent(category)
    const { t } = useTranslation()
    const classes = useStyles()

    const document: item_not_applicable_document_request | null = useMemo(() => {
        const languageDocument = language
            ? language.split('-')[0]
            : null

        return languageDocument && itemNotApplicableDocument[languageDocument] ? `${itemNotApplicableDocument[languageDocument]}#page=${pageNumber}` : null

    }, [language, pageNumber, itemNotApplicableDocument])

    return (
        <Dialog
            open={open}
            maxWidth="lg"
            onClose={onCloseDialog}
        >
            {loadingitemNotApplicableDocument
                ? <CircularProgress />
                : <div 
                    data-testid={testIds.document}
                    className={classes.root}>
                    <iframe
                        title="item_not_applicable_document_view"
                        width={1200}
                        height={900}
                        src={document ? document : ""}
                    />
                    <Button data-testid={testIds.buttonToClose} className={classes.buttonToClose} onClick={onCloseDialog}>{t("common:close")}</Button>
                </div>
            }
            
        </Dialog>
    )
}

export default ItemNotApplicableDocumentDialog